/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum SuggestionCheckAvailableAliases {
  BUTTON_CONFIRM = 'button-confirm',
  CARD_APPOINTMENTS_TITLE_0 = 'card-appointments-title-0',
  CONTEXTUAL_BAR_REQUEST = 'contextual-bar-request',
  FIELD_DATE = 'field-date',
  FIELD_OBS = 'field-obs',
  FIELD_PERIOD = 'field-period',
  FIELD_UPLOAD = 'field-upload',
  FILE_UPLOADER_0 = 'file-uploader-0',
  FORM_REQUEST = 'form-request',
  GLOBAL_ACTIONS_MODAL = 'global-actions-modal',
  INPUT_0 = 'input-0',
  LAYOUT_CONTENT = 'layout-content',
  LAYOUT_REQUEST = 'layout-request',
  MAPPER_AVATAR = 'mapper-avatar',
  PANEL_0 = 'panel-0',
  PANEL_4 = 'panel-4',
  PANEL_6 = 'panel-6',
  PANEL_7 = 'panel-7',
  SEGMENTED_CONTROL_PERIOD = 'segmented-control-period',
  TEXT_0 = 'text-0',
  TEXT_AREA_0 = 'text-area-0',
}
export { SuggestionCheckAvailableAliases };
